import { render } from "./Loading.vue?vue&type=template&id=00b67b22"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v1/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00b67b22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00b67b22', __exports__)) {
    api.reload('00b67b22', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=00b67b22", () => {
    api.rerender('00b67b22', render)
  })

}


export default __exports__